import { useCallback } from 'react';

import { useIsSmartContractWallet } from './useIsSmartContractWallet';

export function useShowBackButtonOnLoginForScw() {
  const isScw = useIsSmartContractWallet();
  const embedded = window.parent !== window;

  return useCallback(() => {
    if (!isScw) {
      return;
    }

    if (!embedded) {
      return;
    }

    postShowBackButtonEvent();
  }, [embedded, isScw]);
}

export function postShowBackButtonEvent(show = true) {
  const messageEvent = {
    eventName: 'backButtonVisibility',
    data: {
      show,
    },
  };

  window.parent.postMessage(JSON.stringify(messageEvent), '*');
}
